import { useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  getRecoveryTokenFromSearch,
  isImplicitRecoveryHash,
} from '../../utils/authRecovery';

/**
 * Sends recovery traffic to /reset-password.
 * - New flow: ?token_hash=…&type=recovery (any path)
 * - Legacy: /#access_token=…&type=recovery after /auth/v1/verify
 */
export function AuthRecoveryRedirect() {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (pathname === '/reset-password') return;

    const type = new URLSearchParams(search).get('type');
    const tokenHash = getRecoveryTokenFromSearch(search);
    if (type === 'recovery' && tokenHash) {
      navigate(`/reset-password${search}`, { replace: true });
      return;
    }

    // Preserve #access_token=… — navigate(pathname) alone drops the hash.
    if (hash && isImplicitRecoveryHash(hash)) {
      const hashValue = hash.startsWith('#') ? hash.slice(1) : hash;
      navigate({ pathname: '/reset-password', hash: hashValue }, { replace: true });
    }
  }, [pathname, search, hash, navigate]);

  return null;
}
